import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { CloudDownload } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import OfflineAlert from '../../../../../offline/components/OfflineAlert/OfflineAlert';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { Order } from '../../../../order.types';
import useOrderObjectOfflineBanner from './hooks/useOrderObjectOfflineBanner';

interface OrderObjectOfflineBannerProps {
  order: Order;
}

const OrderObjectOfflineBanner = ({ order }: OrderObjectOfflineBannerProps) => {
  const { translate } = useTranslation();
  const { alertText, isCompact, downloadBackup } = useOrderObjectOfflineBanner(order);
  const downloadLabel = translate(LangEnum.GLOBAL_DOWNLOAD_BACKUP);

  const downloadAction = isCompact ? (
    <IconButton
      icon={CloudDownload}
      color="secondary"
      size="medium"
      ariaLabel={downloadLabel}
      onClick={downloadBackup}
    />
  ) : (
    <Button
      variant="contained"
      color="secondary"
      size="medium"
      startIcon={<Icon icon={CloudDownload} size="sm" />}
      onClick={downloadBackup}
    >
      {downloadLabel}
    </Button>
  );

  return (
    <OfflineAlert action={downloadAction}>
      <Typography variant="body2">{translate(alertText)}</Typography>
    </OfflineAlert>
  );
};

export default OrderObjectOfflineBanner;
